import { erpAxios } from '..';

const CRKRequest = async (data) => {
  const res = await erpAxios.post(`crkKrediti/add`, data);
  return res;
};

export default CRKRequest;
